import React, { useState } from "react";
import { SettingsPanel } from "./SettingsPanel";
import { LayersPanel } from "./LayersPanel";
import "../../styles/components/editor/EditorPanels.css";

export const EditorPanels: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"settings" | "layers">("settings");

  return (
    <div className="right-panel">
      <div className="panel-tabs">
        <button
          className={`panel-tab-btn ${
            activeTab === "settings" ? "active" : ""
          }`}
          onClick={() => setActiveTab("settings")}
        >
          <span className="panel-tab-icon">⚙️</span>
          Settings
        </button>
        <button
          className={`panel-tab-btn ${activeTab === "layers" ? "active" : ""}`}
          onClick={() => setActiveTab("layers")}
        >
          <span className="panel-tab-icon">📚</span>
          Layers
        </button>
      </div>

      <div className="panel-content">
        {activeTab === "settings" ? <SettingsPanel /> : <LayersPanel />}
      </div>
    </div>
  );
};
